<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- العنوان -->
    <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
      <div>
        <h3 class="fw-bold text-dark">
          <i class="fas fa-layer-group ms-2 text-primary"></i> معالجة وتجميع الدرجات (مفصلة)
        </h3>
        <p class="text-muted small">التحكم في تجميع كل فصل دراسي على حدة، ثم التجميع النهائي للسنة.</p>
      </div>
    </div>

    <!-- ============================================== -->
    <!-- القسم الأول: الفصل الدراسي الأول (Term 1) -->
    <!-- ============================================== -->
    <div class="card shadow-sm border-top-primary mb-4">
      <div class="card-header bg-light d-flex justify-content-between align-items-center">
        <h5 class="mb-0 fw-bold text-primary">1. الفصل الدراسي الأول</h5>
        <span class="badge bg-primary">Term 1</span>
      </div>
      <div class="card-body">
        <div class="row g-3">
          
          <!-- 1. تجميع الرياضيات (ترم 1) -->
          <div class="col-md-6">
            <div class="p-3 border rounded bg-white h-100">
              <h6 class="fw-bold"><i class="fas fa-square-root-alt ms-2 text-warning"></i> رياضيات (ترم أول)</h6>
              <p class="text-muted small mb-3">جمع (الجبر + الهندسة) ووضع الناتج في خانة مجموع الرياضيات.</p>
              <button 
                @click="runProcess('math_term1')" 
                class="btn btn-outline-primary w-100" 
                :disabled="loaders.math_term1"
              >
                <span v-if="loaders.math_term1" class="spinner-border spinner-border-sm"></span>
                <span v-else>تجميع الرياضيات (ت1)</span>
              </button>
            </div>
          </div>

          <!-- 2. المجموع الكلي (ترم 1) -->
          <div class="col-md-6">
            <div class="p-3 border rounded bg-white h-100">
              <h6 class="fw-bold"><i class="fas fa-calculator ms-2 text-success"></i> المجموع الكلي (ترم أول)</h6>
              <p class="text-muted small mb-3">جمع جميع المواد الأساسية + مجموع الرياضيات للترم الأول.</p>
              <button 
                @click="runProcess('total_term1')" 
                class="btn btn-success w-100 text-white" 
                :disabled="loaders.total_term1"
              >
                <span v-if="loaders.total_term1" class="spinner-border spinner-border-sm"></span>
                <span v-else>حساب مجموع الترم الأول</span>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ============================================== -->
    <!-- القسم الثاني: الفصل الدراسي الثاني (Term 2) -->
    <!-- ============================================== -->
    <div class="card shadow-sm border-top-info mb-4">
      <div class="card-header bg-light d-flex justify-content-between align-items-center">
        <h5 class="mb-0 fw-bold text-info-dark">2. الفصل الدراسي الثاني</h5>
        <span class="badge bg-info text-dark">Term 2</span>
      </div>
      <div class="card-body">
        <div class="row g-3">
          
          <!-- 1. تجميع الرياضيات (ترم 2) -->
          <div class="col-md-6">
            <div class="p-3 border rounded bg-white h-100">
              <h6 class="fw-bold"><i class="fas fa-square-root-alt ms-2 text-warning"></i> رياضيات (ترم ثاني)</h6>
              <p class="text-muted small mb-3">جمع (الجبر + الهندسة) مع مراعاة قواعد الغياب (-1).</p>
              <button 
                @click="runProcess('math_term2')" 
                class="btn btn-outline-info w-100 text-dark" 
                :disabled="loaders.math_term2"
              >
                <span v-if="loaders.math_term2" class="spinner-border spinner-border-sm"></span>
                <span v-else>تجميع الرياضيات (ت2)</span>
              </button>
            </div>
          </div>

          <!-- 2. المجموع الكلي (ترم 2) -->
          <div class="col-md-6">
            <div class="p-3 border rounded bg-white h-100">
              <h6 class="fw-bold"><i class="fas fa-calculator ms-2 text-success"></i> المجموع الكلي (ترم ثاني)</h6>
              <p class="text-muted small mb-3">جمع مواد الترم الثاني فقط (مستقلة عن الترم الأول).</p>
              <button 
                @click="runProcess('total_term2')" 
                class="btn btn-info w-100 text-white" 
                :disabled="loaders.total_term2"
              >
                <span v-if="loaders.total_term2" class="spinner-border spinner-border-sm"></span>
                <span v-else>حساب مجموع الترم الثاني</span>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ============================================== -->
    <!-- القسم الثالث: التجميع النهائي (Grand Total) -->
    <!-- ============================================== -->
    <div class="card shadow border-0 border-end border-5 border-danger mb-5">
      <div class="card-body p-4 text-center bg-gradient-light">
        <h3 class="fw-bold text-danger mb-3">
          <i class="fas fa-flag-checkered ms-2"></i> التجميع النهائي للعام الدراسي
        </h3>
        <p class="text-muted w-75 mx-auto mb-4">
          هذه العملية ستقوم بجمع (درجة الترم الأول + درجة الترم الثاني) لكل مادة على حدة ووضعها في الخانة النهائية، 
          وتطبيق قواعد الغياب (إذا غاب في الترم الثاني تُلغى الدرجة)، ثم حساب المجموع الكلي النهائي.
        </p>
        
        <button 
          @click="runProcess('final_total')" 
          class="btn btn-danger btn-lg px-5 py-3 fw-bold shadow hover-up"
          :disabled="loaders.final_total"
        >
          <span v-if="loaders.final_total" class="spinner-border spinner-border-sm ms-2"></span>
          <span v-else><i class="fas fa-check-double ms-2"></i> تنفيذ التجميع النهائي الشامل</span>
        </button>
      </div>
    </div>

    <!-- سجل العمليات -->
    <div class="mt-4" v-if="logs.length > 0">
      <h6 class="fw-bold border-bottom pb-2">سجل العمليات:</h6>
      <div class="bg-dark text-white p-3 rounded font-monospace small" style="max-height: 150px; overflow-y: auto;">
        <div v-for="(log, i) in logs" :key="i" class="mb-1">
          <span class="text-success">[{{ log.time }}]</span> {{ log.message }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "GradesProcessingSplit",
  data() {
    return {
      // حالة التحميل لكل زر بشكل مستقل
      loaders: {
        math_term1: false,
        total_term1: false,
        math_term2: false,
        total_term2: false,
        final_total: false
      },
      logs: []
    };
  },
  methods: {
    async runProcess(type) {
      // رسائل تأكيد مخصصة
      const confirmMsg = {
        math_term1: 'تجميع رياضيات الترم الأول؟',
        total_term1: 'حساب المجموع الكلي للترم الأول؟',
        math_term2: 'تجميع رياضيات الترم الثاني؟',
        total_term2: 'حساب المجموع الكلي للترم الثاني؟',
        final_total: 'بدء التجميع النهائي للسنة وتطبيق قواعد الغياب؟ (تأكد من حساب الترمين أولاً)'
      };

      if (!confirm(confirmMsg[type])) return;

      this.loaders[type] = true;

      try {
        // إرسال نوع العملية للباك إند
        const res = await api.post('/admin/process-grades-step', { step: type });
        
        this.addLog(`تم بنجاح: ${res.data.message}`);
        alert(res.data.message);

      } catch (error) {
        console.error(error);
        this.addLog(`خطأ في تنفيذ: ${type}`);
        alert("حدث خطأ أثناء المعالجة.");
      } finally {
        this.loaders[type] = false;
      }
    },

    addLog(msg) {
      const time = new Date().toLocaleTimeString('en-US', {hour12: false});
      this.logs.unshift({ time, message: msg });
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.border-top-info { border-top: 4px solid #0dcaf0; }
.text-info-dark { color: #055160; }
.bg-gradient-light { background: linear-gradient(to bottom, #ffffff, #f8f9fa); }

/* تأثير الزر الكبير */
.hover-up { transition: transform 0.2s; }
.hover-up:hover { transform: translateY(-3px); }
</style>